import { useContext, useEffect } from 'react';

import { usePacksContext } from '@/components/app/layout/PacksProvider';
import LazyVideoOverlay from '@/components/ui/LazyVideoOverlay';
import { calmLogger } from '@/utils/calmLogger';

import { TransportContainer } from '../AudioPlayer/styles';
import { MediaPlayerContext } from '../MediaPlayerProvider';
import PlayerUpsell from '../PlayerUpsell';

const VideoPlayer = () => {
	const { setMediaEl, onStop, hideControls, autoplayOnLoad } = useContext(MediaPlayerContext);
	const { currentGuide, currentProgram } = usePacksContext();

	useEffect(() => {
		// popstate fires on browser back/forward for both routers; unlike
		// beforePopState it can't block navigation, so we don't need to return
		// anything to let it proceed.
		const handlePopState = () => {
			onStop(true).catch(error => calmLogger.error('Error in VideoPlayer onStop', {}, error));
		};

		window.addEventListener('popstate', handlePopState);
		return () => {
			window.removeEventListener('popstate', handlePopState);
		};
	}, [onStop]);

	if (!currentGuide?.asset?.url) {
		return null;
	}

	if (!currentGuide?.is_free) {
		return (
			<TransportContainer sizeTheme="large">
				<PlayerUpsell isVideo program={currentProgram} />
			</TransportContainer>
		);
	}

	return (
		<LazyVideoOverlay
			withCredentials
			src={currentGuide.asset?.url}
			type="application/x-mpegURL"
			title={currentGuide.short_title || currentGuide.title}
			onClose={() => onStop()}
			setMediaEl={setMediaEl}
			hideControls={hideControls}
			autoplay={autoplayOnLoad}
			disableHotkeys
		/>
	);
};

export default VideoPlayer;
